
// ----------------------获取环境配置-------------------------------
import test from './manifest.test.json';
import devtest from './manifest.devtest.json';
import dev from './manifest.json';
import prod from './manifest.prod.json';
import ly from './manifest.ly.json';


let tmpManifest: any = null;
const getManifest = () => {
	if (tmpManifest) {
		return tmpManifest;
	}

	let mf: any = dev;// 默认取标准版开发环境配置
	switch (REACT_APP_ENV) {
		case 'test':// 公共测试 
			mf = test;
			break;
		case 'devtest':// 本地测试
			mf = devtest;
			break;
		case 'prod':// 生产
			mf = prod;
			break;
		case 'ly':// 龙岩取水监测
			mf = ly;
			break;
		default:
			break;
	}
	tmpManifest = mf;
	return mf;
};
export const manifest = getManifest();
